import { useState } from "react";
import { Colors } from "../constants/colors";

export default function ContactUs() {
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Message from ${name}`);
    const body = encodeURIComponent(message);
    window.location.href = `mailto:hello@naryi.com?subject=${subject}&body=${body}`;
  };

  return (
    <div style={styles.page}>
      <h1>Contact Us</h1>
      <form onSubmit={handleSubmit} style={styles.contactForm}>
        <input
          type="text"
          placeholder="Your Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={styles.input}
          required
        />
        <textarea
          placeholder="Your Message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          style={{ ...styles.input, height: 120 }}
          required
        />
        <button type="submit" style={styles.button}>
          Send Email
        </button>
      </form>
    </div>
  );
}

const styles = {
  page: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "80vh",
    fontFamily: "Retrograde, system-ui, sans-serif",
    backgroundColor: Colors.background.light,
    color: "#333",
    textAlign: "center",
    padding: 20,
  },
  contactForm: {
    display: "flex",
    flexDirection: "column",
    gap: 15,
    width: "100%",
    maxWidth: 400, // ✅ ensures consistent width for inputs + button
    marginTop: 20,
  },
  input: {
    padding: "10px 12px",
    borderRadius: 8,
    border: "1px solid #ccc",
    fontSize: 16,
    fontFamily: "Retrograde, system-ui, sans-serif",
    width: "100%", // ✅ same width as parent (400px)
    boxSizing: "border-box",
  },
  button: {
    padding: "12px 12px",
    borderRadius: 8,
    border: "none",
    fontFamily: "Retrograde, system-ui, sans-serif",
    backgroundColor: Colors.buttonImportantSecondary.light,
    color: "#fff",
    fontSize: 16,
    fontWeight: 600,
    cursor: "pointer",
    width: "100%", // ✅ matches inputs exactly
    boxSizing: "border-box",
  },
};
